import React from 'react';

function Programs () {
    return <h1>Welcome to Programs Page</h1>
}


export default Programs;
